const STATUS_LABELS: Record<string, string> = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In progress',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  CANCELED: 'Canceled',
  CANCELLED: 'Canceled',
  COMPLETED: 'Completed',
};

const STATUS_MESSAGES: Record<string, string> = {
  PENDING: 'This request is waiting for approval.',
  IN_PROGRESS: 'This request is being reviewed.',
  APPROVED: 'This request was approved.',
  REJECTED: 'This request was rejected.',
  CANCELED: 'This request was canceled.',
  CANCELLED: 'This request was canceled.',
  COMPLETED: 'This workflow is complete.',
};

const STATUS_CATEGORIES: Record<
  string,
  'neutral' | 'success' | 'warning' | 'danger' | 'info'
> = {
  PENDING: 'warning',
  IN_PROGRESS: 'info',
  APPROVED: 'success',
  REJECTED: 'danger',
  CANCELED: 'neutral',
  CANCELLED: 'neutral',
  COMPLETED: 'success',
};

const ACTION_LABELS: Record<string, string> = {
  SUBMITTED: 'Submitted',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  FORWARDED: 'Forwarded',
  DELEGATED: 'Delegated',
  CANCELED: 'Canceled',
  CANCELLED: 'Canceled',
};

export function getWorkflowStatusLabel(
  status: string | null | undefined,
): string {
  if (!status) return 'Status unavailable';
  return STATUS_LABELS[status.toUpperCase()] ?? 'Status unavailable';
}

export function getWorkflowStatusMessage(
  status: string | null | undefined,
): string {
  if (!status) return 'Workflow status is unavailable.';
  return (
    STATUS_MESSAGES[status.toUpperCase()] ?? 'Workflow status is unavailable.'
  );
}

export function getWorkflowStatusCategory(
  status: string | null | undefined,
): 'neutral' | 'success' | 'warning' | 'danger' | 'info' {
  if (!status) return 'neutral';
  return STATUS_CATEGORIES[status.toUpperCase()] ?? 'neutral';
}

export function getWorkflowActionLabel(
  action: string | null | undefined,
): string {
  if (!action) return 'Workflow updated';
  return ACTION_LABELS[action.toUpperCase()] ?? 'Workflow updated';
}

export function isPendingWorkflowActionStatus(
  status: string | null | undefined,
): boolean {
  const category = getWorkflowStatusCategory(status);
  return category === 'warning' || category === 'info';
}

export function isApprovedWorkflowStatus(
  status: string | null | undefined,
): boolean {
  return getWorkflowStatusCategory(status) === 'success';
}

export function isHrDashboardRequestStatus(
  status: string | null | undefined,
): boolean {
  return (
    isPendingWorkflowActionStatus(status) || isApprovedWorkflowStatus(status)
  );
}

export function isRejectedWorkflowStatus(
  status: string | null | undefined,
): boolean {
  return (status || '').toUpperCase() === 'REJECTED';
}

export function isCancelledWorkflowStatus(
  status: string | null | undefined,
): boolean {
  const code = (status || '').toUpperCase();
  return code === 'CANCELLED' || code === 'CANCELED';
}
